import { selectIsRunActive, useVibeAgentStore } from './store'

/**
 * Canonical "is a build run active for this flow" accessor for surfaces OUTSIDE
 * the sidebar (title-bar actions, scenario runners) that must lock while a build
 * is in flight. External consumers read this facade, never the raw store.
 */
export const useVibeRunActive = (): boolean => useVibeAgentStore(selectIsRunActive)
